import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import Accordion from 'react-bootstrap/Accordion';

const GradingsTab = ({
  assessments,
  enrolledStudents,
  gradingsList,
  setSelectedAssessment,
  setSelectedStudent,
  selectedAssessment, // Fixed: Added to props
  selectedStudent,
  assAttempts
}) => {
  return (
    <Box mt={3} display={'flex'} gap={2} flexWrap={'wrap'}>
      <Box sx={{flex: 1, minWidth: {xs: '300px', sm: '400px', md: '150px'}, maxWidth: {xs: '600px', sm: '600px', md: '200px'}}}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Assessments
        </Typography>
        <Typography variant="h6" gutterBottom>
          Select an Assessment to Grade
        </Typography>
        <List>
          {assessments.map((assessment) => (
            <ListItem
              sx={{backgroundColor: '#ecfafd9f', borderRadius: '.3rem', marginBottom: '.3rem', cursor: 'pointer'}}
              key={assessment.id}
              button={true}
              onClick={() => {
                setSelectedAssessment(assessment);
              }}
            >
              <ListItemText
                primary={`${assessment.assess_number}. ${assessment.name}`}
                secondary={assessment.description || ''}
              />
            </ListItem>
          ))}
        </List>
      </Box>
      <Box sx={{flex: 1, minWidth: {xs: '300px', sm: '200px', md: '150px'}, maxWidth: {xs: '600px', sm: '600px', md: '200px'}, border: '.1rem solid #fff', borderRadius: '.3rem', padding: '1rem'}} boxShadow={2}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Enrolled Students
        </Typography>
        {enrolledStudents.length > 0 ? (
          enrolledStudents.map(student => (
            <Typography key={student.id}>{student.firstName} {student.lastName} {student.id}</Typography>
          ))
        ) : (
          <Typography>No Student enrolled</Typography>
        )}
      </Box>
      <Box sx={{flex: 1, minWidth: {xs: '300px', sm: '200px', md: '150px'}, maxWidth: {xs: '600px', sm: '600px', md: '200px'}, border: '.1rem solid #fff', borderRadius: '.3rem', padding: '1rem'}} boxShadow={2}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          {selectedAssessment? `${selectedAssessment.name}-Attempts`:"Students Attempt"}
        </Typography>
        {selectedAssessment !== null ? (
          gradingsList.length > 0 ? (
            enrolledStudents.map(student => (
              <ListItem
                sx={{backgroundColor: '#2cf79175', borderRadius: '.3rem', marginBottom: '.3rem', cursor: 'pointer'}}
                key={student.id}
                button={true}
                onClick={() => {
                  setSelectedStudent(student);
                }}
              >
                <ListItemText
                  primary={`${student.firstName} ${student.lastName}`}
                  secondary={`Student Number: ${student.id}`}
                />
              </ListItem>
            ))
          ) : (
            <Typography>No student Attempt</Typography>
          )
        ) : (
          <Typography>No Assessment selected</Typography>
        )}
      </Box>
      <Box sx={{flex: 1, minWidth: "350px"}}>
        {gradingsList.length > 0 && selectedStudent ? (
          <>{
            gradingsList.map(grade =>
              <Box key={grade.id}>
                {
                  grade.student_ID === selectedStudent.id && (
                    <Box>
                      <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <Typography variant="h5" fontWeight={700} gutterBottom>
                          {`${selectedStudent.firstName} ${selectedStudent.lastName}-Attempt`}
                        </Typography>
                        <Typography variant="h5" fontWeight={700} gutterBottom>
                          {`SCORE: ${grade.score} / ${selectedAssessment.weight}`}
                        </Typography>
                        <Typography variant="h5" fontWeight={700} gutterBottom>
                          {`WEIGHT: ${grade.score} %`}
                        </Typography>
                      </Box>
                      <Box sx={{ width: '100%', minHeight: '300px', borderTop: '.1rem solid #d0edfaea'}}>
                        {/* Add content here */}
                        <Accordion style={{ width: '100%', margin: '1rem 0 0 0' }}>
                          <Accordion.Item eventKey={grade.id || Math.random()}>
                            <Accordion.Header>Manage student attempt </Accordion.Header>
                            <Accordion.Body>
                              <Box>

                              </Box>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      </Box>
                    </Box>
                  )
                }
              </Box>
            )
          }</>
        ) : (
          <Typography>No student selected</Typography>
        )}
      </Box>
    </Box>
  );
};

export default GradingsTab;